import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AmaComponent } from './ama.component';
import { AskCrownitComponent } from './ask-crownit/ask-crownit.component';
import { AskListComponent } from './ask-list/ask-list.component';
import { AskRequestPreviewComponent } from './ask-request-preview/ask-request-preview.component';
import { ViewDetailsComponent } from './view-details/view-details.component';

const routes: Routes = [{
  path:'',
  component:AmaComponent,
  children:[
    
    {path:'',component:AskListComponent},
    {path:'request-list',component:AskListComponent},
    {path:'ask-crownit',component:AskCrownitComponent},
    {path:'request-review',component:AskRequestPreviewComponent},
    {path:'view-details/:Id',component:ViewDetailsComponent},
    
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AmaRoutingModule { }
